import {
  DCPFacetContainerDTO,
  SMSFacet,
  SMSFacetValue,
  SMSPagination,
} from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';

export type IProductFilterDTO = Required<SMSFacet> & { value?: any; step?: number };
export type IProductFilterPaginationDTO = Required<SMSPagination>;
export type IProductFilterContainerDTO = Required<DCPFacetContainerDTO>;
export type IProductFilterValueDTO = Required<SMSFacetValue> & { disabled: boolean; value: any };

export type IProductFilterOptionDTO = {
  code?: string;
  count?: number | string;
  disabled?: boolean;
  name?: string;
  value?: string;
  selected?: boolean;
  query?: { query?: { value?: string }; url?: string };
};

export type IProductFilterGroup = {
  code: FilterContainerCode;
  name: any;
  icon: string;
  filters: ProductFilterBase[];
  filterNames?: string[];
  sideFilters?: string[];
  hideFilterTitles?: boolean;
};

export type IProductFilterField = {
  filterCode: string;
  filterType?: any;
  filterValue: string;
  filterCurrentlySelectedItemValue: string | string[];
  selected: boolean;
};

export interface ISelectedFilter {
  filterCode: string;
  filterLabel: string;
  filterValue?: string | number;
  filterType: string;
  filterTrackingValue?: string;
}

export enum FilterContainerCode {
  vehicle = 'vehicle',
  stockType = 'stockType',
  price = 'price',
  engine = 'engine',
  upholstery = 'upholstery',
  equipment = 'equipment',
  color = 'color',
  transportUsage = 'transportUsage',
  campaign = 'campaign',
  highlights = 'highlights',
  locations = 'locations',
}

// Add all filter.code values here in the future and update to usage of this enum instead of simple strings
export enum FilterCode {
  allCategories = 'allCategories',
  b2bFilterPrice = 'b2bFilterPrice',
  b2bInstalmentRate = 'b2bInstalmentRate',
  b2cFilterPrice = 'b2cFilterPrice',
  b2cInstalmentRate = 'b2cInstalmentRate',
  badges = 'badges',
  bodyType = 'bodyType',
  brand = 'brand',
  colorGroup = 'color_group',
  colorPolish = 'color_polish',
  combinedPower = 'combinedPower',
  driveType = 'driveType',
  equipmentGroups = 'equipmentGroups',
  fuelType = 'fuel_type',
  gearBox = 'gearBox',
  lines = 'lines',
  loadingSpaceVolume = 'loadingSpaceVolume',
  loadingSpaceWidth = 'loadingSpaceWidth',
  loadingSpaceHeight = 'loadingSpaceHeight',
  loadingSpaceLength = 'loadingSpaceLength',
  locations = 'locations',
  maxLoad = 'maxLoad',
  maxWeight = 'maxWeight',
  model = 'model',
  modelDesignation = 'modelDesignation',
  monthlyRate = 'monthlyRate',
  numberOfSeats = 'numberOfSeats',
  packages = 'packages',
  priceValue = 'priceValue',
  stockType = 'stockType',
  upholsteryGroup = 'upholstery_group',
  upholsteryPolish = 'upholstery_polish',
}

export enum ProductFilterTypes {
  SingleSelect,
  MultiSelect,
  Slider,
  Checkbox,
  PriceSlider,
}

export default abstract class ProductFilterBase implements IProductFilterDTO {
  category: boolean;
  code: string;
  container: IProductFilterContainerDTO;
  displayName: string;
  facetDisplayType: 'SLIDER' | 'PRICE_SLIDER' | 'CHECKBOX' | 'DROPDOWN_SINGLE';
  from: number;
  fromFormatted: string;
  label: string;
  max: number;
  maxFormatted: string;
  min: number;
  minFormatted: string;
  multiSelect: boolean;
  name: string;
  options?: IProductFilterOptionDTO[];
  priority: number;
  to: number;
  toFormatted: string;
  topValues: IProductFilterValueDTO[];
  type: number;
  value: any = null;
  values: IProductFilterValueDTO[];
  visible = true;

  abstract clone(): any;

  abstract isSelected(): boolean;

  abstract getResetValue(): any;

  getQueryValue(): string {
    return `:${this.code}:${this.value}`;
  }
}
